export default __webpack_public_path__ + "static/media/open-pod-image.8964cb85.png";